module.exports = __webpack_public_path__ + "img/zeca-icon-shadow.a47a2903.svg";